import * as freeSolidIcons from './free-solid'
import * as freeRegularIcons from './free-regular'
import * as proDuotoneIcons from './pro-duotone'
import * as proLightIcons from './pro-light'
import * as proSolidIcons from './pro-solid'

export const fontAwesomeIcons = {
  ...freeSolidIcons,
  ...freeRegularIcons,
  ...proDuotoneIcons,
  ...proLightIcons,
  ...proSolidIcons,
}

const fontAwesomeLibrary = Object.values(fontAwesomeIcons)

export default fontAwesomeLibrary
